<li [class.dragging]="isDragging$ | async">
  <div class="bord-wrapper">
    <div class="bord bord--hook" [dragSource]="source" [noHTML5Preview]="true">
      <img class="bord__icon" src="./assets/images/bord/2x/{{percussion.icon}}.png">
    </div>
  </div>
</li>
